module.exports = __webpack_public_path__ + "static/integrations-mobile-03944294b38803a565202218f15b9b1b.png";